export enum FieldType {
  Main = "Main",
  Fake = "Fake",
  Input = "Input",
}

export enum CourseName {
  TP_TD = "TP_TD",
  TD = "TD",
  TN = "TN",
  TP = "TP",
  TT = "TT",
  TU = "TU",
  TZ = "TZ",
}
